"use client";
import type { ReactElement, ReactNode, Ref } from "react";
import { Cstretchmodal } from "../Cstretchmodal/Cstretchmodal";
import { Ctext } from "../Ctext";
import { TextPreset } from "@/constants/componentPresets";
import { FontWeight } from "@/theme/typography";
import { TOP_BAR_DOT_STYLE } from "./CmarkdownvisualStyles";
interface CmarkdownvisualModalProps {
    bodyRef: Ref<HTMLDivElement>;
    isOpen: boolean;
    modalControls?: ReactNode;
    onClose: () => void;
    type: string;
}
export function CmarkdownvisualModal({ bodyRef, isOpen, modalControls, onClose, type, }: CmarkdownvisualModalProps): ReactElement {
    const modalHeader = (
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <span style={TOP_BAR_DOT_STYLE}/>
        <Ctext preset={TextPreset.Strong} size={25} weight={FontWeight.Heavy}>
          {type}
        </Ctext>
      </div>
    );
    return (<Cstretchmodal dataElScope="Cmarkdownvisual/CmarkdownvisualModal" visible={isOpen} onClose={onClose} header={modalHeader} footer={modalControls} floatingFooter={Boolean(modalControls)} bodyRef={bodyRef}/>);
}
